import { rem } from '../../../utils/rem';
export var MuiListSubheader = {
    styleOverrides: {},
    customOverrides: {
        sideNavSubheader: {
            background: 'transparent',
            lineHeight: rem(20),
            padding: "".concat(rem(16), " ").concat(rem(8), " ").concat(rem(8)),
            textTransform: 'uppercase',
            fontSize: rem(12),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
        },
    },
};
